import $ from 'jquery';  // Import jQuery

let modal_opening_id = "";
let modal_bitmation_time = 250;

export function bindModalOpen(){
    $('[data-modal]').on('click', function(e){
        e.preventDefault();
        var elem = $(this),
            modal = elem.data('modal'),
            navigation = $('#main-navigation'),
            modals = $('.modal');
        slideMainMenu(navigation.find('.main-menu'), navigation.find('.overlay'), 'close');
        modals.hide();
        modal_opening_id = elem.attr('id');
        openModal(modal);
    });
}
/**
 * bind_modal_close
 */
export function bindModalClose(){
    $('.close-modal, .modal .overlay').on('click', function(e){
        e.preventDefault();
        var elem = $(this),
            parent = elem.closest('.modal'),
            modal = parent.attr('id');
        closeModal(modal);
    });
}
/**
 * open_modal
 * @param id
 */
export function openModal(id){
    var modal = $('#'+ id);
    modal.find('.overlay').show();
    modal.stop().fadeIn(modal_bitmation_time);
}
/**
 * close_modal
 * @param id
 */
export function closeModal(id){
    var modal = $('#'+ id);
    modal.stop().fadeOut(modal_bitmation_time, function(){
        modal.find('.overlay').hide();
    });
}
